// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__3gHCh","taskSucceeded":"style_taskSucceeded__1xgOS","title":"style_title__2hzV4","taskFailed":"style_taskFailed__3vhBa","taskTime":"style_taskTime__1v_3e"};